import axios from 'axios'

const baseURL = 'https://api.matsuya.com.br'

const api = axios.create({
  baseURL,
});

export default api;
